<template>
  <client-only>
    <div
      :class="['footer-share-content', addClass, region]"
      v-if="buttonList.length"
    >
      <div
        :class="['card', item.className]"
        v-for="(item, index) in buttonList"
        :key="index"
        :style="cardStyles"
        @click="clickHandler(item.name)"
      >
        <img
          v-if="item.iconImage"
          :src="item.iconImage"
          alt="telegram"
          class="telegram-icon"
        />
        <MBIcon
          v-else
          :size="item.iconSize"
          :name="item.iconName"
          :color="mFontColor.color"
        />
        <p :style="mFontColor">
          {{ item.text }}
        </p>
      </div>
      <MobileShare ref="mobileShare" />
    </div>
  </client-only>
</template>
<script>
  import MBIcon from '@/components/MBIcon'
  import styleConfiguration from '@/mixins/detail/styleConfiguration'
  import { shareShow, facebookHome, faqClick } from '@/pages/firebase'
  import { mapState, mapGetters } from 'vuex'
  import { MobileShare } from '@/components/PublicShare'
  import { jumpToPage } from '@/utils/utils'
  import { officialLinks } from '@/consts'

  export default {
    name: 'footer-button',
    mixins: [styleConfiguration],
    components: {
      MBIcon,
      MobileShare,
    },
    data() {
      return {
        iconNameList: ['icon-share', 'icon-qa', 'icon-fk'],
      }
    },
    computed: {
      ...mapState(['gameName', 'isGetapps', 'isApp', 'region']),
      ...mapGetters(['isGenshinEn']),

      addClass() {
        if (this.buttonList.length) {
          return this.buttonList.length === 2 ? 'dichotomy' : ''
        }
        return ''
      },

      cardStyles() {
        return this.moduleBackColor
      },
      footerList() {
        return [
          {
            name: 'share',
            iconName: 'icon-share',
            iconSize: 60,
            text: this.$t(`common.share`),
            className: 'share',
          },
          {
            name: 'telegram',
            iconSize: 60,
            iconImage: require('@/assets/images/common/icon/telegram-footer.png'),
            text: this.$t(`common.telegram_home`),
            className: 'telegram',
          },
          /*不显示facebook*/
          /*{
            name: 'faq',
            iconName: 'icon-qa',
            iconSize: 60,
            text: this.$t(`common.customer_feedback`),
            className: 'feedback',
          },*/
          {
            name: 'facebook',
            iconName: 'icon-fk',
            iconSize: 60,
            text: this.$t(`common.facebook_home`),
            className: 'fb-home',
          },
          {
            name: 'vk',
            iconName: 'icon-VK',
            iconSize: 60,
            text: this.$t(`common.vk_home`),
            className: 'vk-home',
          },
        ]
      },
      buttonList() {
        if (this.isGetapps) return []
        // 针对US 是隐藏【反馈入口】
        if (this.isGenshinEn) {
          return this.footerList.filter((item) => item.name !== 'faq')
        }
        // vk只在俄罗斯展示
        if (this.region !== 'ru') {
          return this.footerList.filter(
            (item) => item.name !== 'vk' && item.name !== 'telegram'
          )
        } else {
          return this.footerList.filter((item) => item.name !== 'fb')
        }
      },
    },
    methods: {
      clickHandler(type) {
        const ItemClickEventMaps = {
          faq: this.clickFAQ,
          facebook: this.clickFacebook,
          share: this.clickShare,
          telegram: this.clickTelegram,
          vk: this.clickVk,
        }
        ItemClickEventMaps[type] && ItemClickEventMaps[type]()
      },
      clickFAQ() {
        faqClick({ page: this.gameName })
        this.$router_push({
          path: '/contact',
          query: {
            ...this.$route.query,
          },
        })
      },
      clickFacebook() {
        facebookHome({ page: this.gameName })
        jumpToPage(officialLinks.fb)
      },
      clickShare() {
        this.$refs.mobileShare && this.$refs.mobileShare.switch()
        // 点击分享按钮(分享媒体曝光)打点
        shareShow({ page: this.gameName }, 'van-share-sheet')
      },
      clickTelegram() {
        jumpToPage(officialLinks.telegram)
      },
      clickVk() {
        jumpToPage(officialLinks.vk)
      },
    },
  }
</script>
<style scoped lang="scss" src="./styles.scss"></style>
